<template>
  <!-- 子商品新增/编辑 -->
  <a-modal v-model:open="childrenFormModal.show" :title="childrenFormModal.title" centered width="600px" destroyOnClose :getContainer="getContainer">
    <a-form :model="childrenFormModal" labelAlign="right" :label-col="{ style: { width: '70px' } }" :wrapper-col="{ span: '20' }">
      <a-form-item label="商品名称">
        <el-input
          type="textarea"
          style="width: 180px"
          v-model="childrenFormModal.name"
          placeholder="请输入商品名称"
          :maxlength="50"
          :autosize="{ minRows: 1 }"
        />
        <span style="margin-left: 50px">序号：</span>
        <el-input
          style="width: 180px"
          :modelValue="childrenFormModal.sort"
          placeholder="字母+数字"
          :maxlength="3"
          @input="(val) => sortChange(val, childrenFormModal)"
        />
      </a-form-item>
      <a-form-item label="备注名称">
        <el-input
          type="textarea"
          style="width: 180px"
          v-model="childrenFormModal.remark_name"
          placeholder="请输入备注名称"
          :maxlength="50"
          :autosize="{ minRows: 1 }"
        />
        <span style="margin-left: 50px">重量：</span>
        <el-input
          style="width: 180px"
          :modelValue="childrenFormModal.weight"
          suffix="kg"
          placeholder="如:0.2"
          @input="(value) => weightchange({ target: { value } }, childrenFormModal)"
        />
      </a-form-item>
      <a-form-item label="供应商">
        <a-select
          style="width: 180px"
          v-model:value="childrenFormModal.sup_id"
          :options="supplierList"
          placeholder="请选择供应商"
          show-search
          optionFilterProp="label"
          :disabled="hasAuthority(['29'])"
        >
          <template #dropdownRender="{ menuNode: menu }">
            <v-nodes :vnodes="menu" />
            <a-divider style="margin: 4px 0" />
            <div class="select-add-item" @mousedown="(e) => e.preventDefault()" @click="addSupplier">
              <ehf-icon icon="add-circle-line"></ehf-icon>
              <span style="margin-left: 10px">新增供应商</span>
            </div>
          </template>
        </a-select>
        <span style="margin-left: 50px">单位：</span>
        <a-select style="width: 180px" v-model:value="childrenFormModal.unit" option-label-prop="label" placeholder="请选择单位" show-search>
          <a-select-option class="tag-item" v-for="item in unitList" :value="item.label" :key="item.value" :label="item.label">
            {{ item.label }}
            <ehf-icon icon="close-circle-fill" class="close-icon" style="float: right" @click="deleteUnit($event, item.value)" />
          </a-select-option>
          <template #dropdownRender="{ menuNode: menu }">
            <v-nodes :vnodes="menu" />
            <a-divider style="margin: 4px 0" />
            <div class="select-add-item" @mousedown="(e) => e.preventDefault()" @click="addUnit">
              <ehf-icon icon="add-circle-line"></ehf-icon>
              <span style="margin-left: 10px">新增单位</span>
            </div>
          </template>
        </a-select>
      </a-form-item>
      <a-form-item label="装箱规格">
        <el-input style="width: 180px" v-model="childrenFormModal.pack_size" placeholder="请输入装箱规格" :maxlength="20" />
        <span style="margin-left: 50px">货号：</span>
        <el-input style="width: 180px" v-model="childrenFormModal.product_code" placeholder="请输入货号" :maxlength="20" />
      </a-form-item>
      <a-form-item label="商品图片">
        <ehf-image-upload v-model="childrenFormModal.img_url" :getContainer="getContainer" />
      </a-form-item>
    </a-form>
    <template #footer>
      <a-button type="primary" @click="saveChildrenItem(childrenFormModal)">保存</a-button>
    </template>
  </a-modal>
</template>

<script setup>
  import { reactive, toRefs, watch } from 'vue'
  import { hasAuthority } from '@/utils'
  const props = defineProps({
    getContainer: {
      type: Function,
      default: () => {
        return document.body
      },
    },
    supplierList: {
      type: Array,
      default: () => {
        return []
      },
    },
    unitList: {
      type: Array,
      default: () => {
        return []
      },
    },
  })
  const { supplierList, unitList } = toRefs(props)
  const emit = defineEmits(['save', 'addSupplier', 'addUnit', 'deleteUnit'])
  const childrenFormModal = reactive({
    show: false,
    title: '新增子商品',
    id: '',
    name: '', // 商品名称
    remark_name: '', //备注名称
    sort: '', // 序号
    weight: '', // 重量
    unit: '', // 单位
    sup_id: null, // 供应商
    product_code: '', // 货号
    pack_size: '', // 规格
    img_url: '', // 图片
  })
  watch(supplierList, (val) => {
    if (val.length > 0 && childrenFormModal.sup_id) {
      const index = val.findIndex((v) => v.value === childrenFormModal.sup_id)
      if (index === -1) {
        childrenFormModal.sup_id = null
      }
    }
    //判断是否是供应商身份，供应商身份默认选择自己并禁用
    if (hasAuthority(['29']) && val.length > 0) {
      childrenFormModal.sup_id = val[0].value
    }
  })
  watch(unitList, (val) => {
    if (val.length > 0 && childrenFormModal.unit) {
      const index = val.findIndex((v) => v.label === childrenFormModal.unit)
      if (index === -1) {
        childrenFormModal.unit = null
      }
    }
  })
  const VNodes = (_, { attrs }) => {
    return attrs.vnodes
  }

  // 新增/编辑子商品
  const setChildItemForm = (item, last_item) => {
    const isEdit = item ? true : false
    childrenFormModal.title = isEdit ? '编辑子商品' : '新增子商品'
    childrenFormModal.id = isEdit ? item.id : ''
    childrenFormModal.name = isEdit ? item.name : ''
    childrenFormModal.remark_name = isEdit ? item.remark_name : ''
    childrenFormModal.sort = isEdit ? item.sort : ''
    childrenFormModal.weight = isEdit ? item.weight : ''
    childrenFormModal.unit = isEdit ? item.unit : last_item ? last_item.unit : null
    childrenFormModal.sup_id = isEdit ? item.sup_id : last_item ? last_item.sup_id : null
    childrenFormModal.product_code = isEdit ? item.product_code : ''
    childrenFormModal.pack_size = isEdit ? item.pack_size : ''
    childrenFormModal.img_url = isEdit ? item.img_url : ''
    childrenFormModal.show = true
    if (supplierList.value.length > 0 && childrenFormModal.sup_id) {
      const index = supplierList.value.findIndex((v) => v.value === childrenFormModal.sup_id)
      if (index === -1) {
        childrenFormModal.sup_id = null
      }
    }
    //判断是否是供应商身份，供应商身份默认选择自己并禁用
    if (hasAuthority(['29']) && supplierList.value.length > 0) {
      childrenFormModal.sup_id = supplierList.value[0].value
    }
    if (unitList.value.length > 0 && childrenFormModal.unit) {
      const index = unitList.value.findIndex((v) => v.label === childrenFormModal.unit)
      if (index === -1) {
        childrenFormModal.unit = null
      }
    }
  }

  // 序号变化
  const sortChange = (value, item) => {
    const reg_1 = /^[a-zA-Z]?$/
    const reg_2 = /^[a-zA-Z][0-9]{0,2}$/
    if (!reg_1.test(value) && !reg_2.test(value)) {
      return
    }
    item.sort = value.toUpperCase()
  }
  // 重量变化
  const weightchange = (e, record) => {
    const { value } = e.target
    const reg = /^[0-9]*(\.[0-9]{0,2})?$/
    if ((!isNaN(value) && reg.test(value)) || value === '') {
      record.weight = value
    }
  }
  const saveChildrenItem = (info) => {
    emit('save', info)
  }
  const addSupplier = () => {
    emit('addSupplier')
  }
  const addUnit = () => {
    emit('addUnit')
  }
  const deleteUnit = (e, id) => {
    emit('deleteUnit', e, id)
  }

  defineExpose({
    childrenFormModal,
    setChildItemForm,
  })
</script>

<style lang="scss" scoped>
  .tag-item {
    .close-icon {
      display: none;
      color: #999999;
      &:hover {
        color: #ed4014;
      }
    }
    &:hover {
      .close-icon {
        display: block;
      }
    }
  }
  .select-add-item {
    padding: 4px 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }
</style>
